import { render, staticRenderFns } from "./standardSettingsDialog.vue?vue&type=template&id=6bfef5c1&scoped=true"
import script from "./standardSettingsDialog.vue?vue&type=script&lang=js"
export * from "./standardSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./standardSettingsDialog.vue?vue&type=style&index=0&id=6bfef5c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfef5c1",
  null
  
)

export default component.exports